import * as types from '../../actions/types';

export default (state = { timeseriesData: {} }, action) => {
  let newData
  switch(action.type) {
    case types.SET_TIMESERIES_LOADING:
      newData = { ...state.timeseriesData }
      if (!newData[action.location_id]) {
        newData[action.location_id] = {}
      }
      newData[action.location_id][action.isp] = { loading: true }
      return { ...state, timeseriesData: newData }
    case types.TIMESERIES_ERROR_LOADING:
      newData = { ...state.timeseriesData }
      if (!newData[action.location_id]) {
        newData[action.location_id] = {}
      }
      newData[action.location_id][action.isp] = { error: true }
      return { ...state, timeseriesData: newData }
    case types.RECEIVE_TIMESERIES:
      newData = { ...state.timeseriesData }
      if (!newData[action.location_id]) {
        newData[action.location_id] = {}
      }
      newData[action.location_id][action.isp] = action.timeseries
      return { ...state, timeseriesData: newData }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/timeseries.js